import React, { useEffect, useState } from "react";
import { MainWrapper, ProgressBar, ProgressBarWrapper, ContentWrapper } from "./style";
import { Text } from "components/Text";
import { XCircle } from "assets/icons";
import { StyledText } from "components/MainViewCard/CardDescription/style";
import { ToastProps } from "./types";

export const Toast: React.FC<ToastProps> = ({ type, message, duration = 3000, onClose, showCloseIcon = true, actionHandler, actionText }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, duration);

    const interval = setInterval(() => {
      setProgress((prev) => Math.max(prev - (100 / (duration / 100)), 0));
    }, 100);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [duration, onClose]);

  return (
    <MainWrapper>
    <ContentWrapper $type={type}>
      { showCloseIcon && (
        <XCircle onClick={onClose} width={24} height={24}/>
      )}
      <Text $textVariant="pSM" $textColor="text500">{message}</Text>
      { actionText && (
        <StyledText $textVariant="pSM" $textColor="text500" onClick={actionHandler}>{actionText}</StyledText>
      )}
    </ContentWrapper>
      <ProgressBarWrapper>
        <ProgressBar $width={progress} $type={type}/>
      </ProgressBarWrapper>
    </MainWrapper>
  );
}